<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div
    #nomenclatureform
    style="min-height: 55rem">
    <div class="grid">
      <div class="col-12">
        <p-card>
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium required-field">Название</label>
              <crm-input-text
                [(value)]="nomenclature.name"
                [isError]="$any(errors?.name)"></crm-input-text>
              <small
                *ngIf="errors?.name"
                class="p-error">
                {{ errors.name | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium required-field">Тип</label>
              <crm-single-select
                [options]="types"
                [(selectedItem)]="nomenclature.type"
                [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
                [filter]="false"
                [isTemplateCombined]="true"
                optionValue="name"
                appendTo="body">
                <ng-template
                  #itemTemplate
                  let-type="item">
                  {{ type.value | nomenclatureTypeName }}
                </ng-template>
              </crm-single-select>
              <small
                *ngIf="errors?.type"
                class="p-error">
                {{ errors.type | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Цена</label>
              <p-inputNumber
                [(ngModel)]="nomenclature.price"
                [min]="0"
                class="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"
                styleClass="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"></p-inputNumber>
              <small
                *ngIf="errors?.price"
                class="p-error">
                {{ errors.price | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Группа</label>
              <crm-nomenclature-group-single-select
                [(selectedNomenclature)]="nomenclature.group"
                [nomenclatures]="groups"
                appendTo="nomenclatureform"></crm-nomenclature-group-single-select>
              <small
                *ngIf="errors?.group"
                class="p-error">
                {{ errors.group | join }}
              </small>
            </div>

            <div
              *ngIf="nomenclature?.deleted"
              class="text-right">
              <p-tag
                severity="danger"
                value="Удалена"
                styleClass="mt-2"></p-tag>
            </div>
          </div>
        </p-card>

        <div
          class="mt-3"
          *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
          <crm-directory-common-history
            [entityName]="DirectoryCommonHistoryTypeEnum.NOMENCLATURE"
            [entityId]="formStoreService.getState.forms[this.index]?.entityId"
            [apiService]="nomenclatureItemService">
          </crm-directory-common-history>
        </div>
      </div>
    </div>

    <div
      *ngIf="(form$ | async)?.canWrite"
      class="mt-3">
      <div class="flex flex-wrap justify-content-between">
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success"
          (onClick)="saveNomenclature()"></crm-button>

        <div class="flex align-items-center gap-2">
          <crm-button
            *ngIf="(form$ | async)?.isShowDelete && !nomenclature?.deleted"
            label="Удалить"
            styleClass="p-button-danger p-button-text"
            (onClick)="deleteNomenclature()"></crm-button>
          <crm-button
            *ngIf="(form$ | async)?.isShowDelete && nomenclature?.deleted"
            icon="pi pi-undo"
            label="Восстановить"
            styleClass="p-button-info p-button-text"
            (onClick)="restoreNomenclature()"></crm-button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
